module.exports = __webpack_public_path__ + "static/img/web13.909d131.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/web/web13.png
// module id = nR/8
// module chunks = 0